import styled from 'styled-components';

// List = rail do design Operacional.html.
// Estrutura: rail-head (chip cyan + icons) + commands + hint + vars
// (scrollable, hairlines entre rows).

// Container do rail — flex column ocupando 100% da altura (RightColumnGrid
// e flex column tambem). min-height 0 + overflow hidden permite que .vars
// interna scrolle sem empurrar a altura.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
`;

// rail-head — chip "Variáveis e comandos" cyan + icones lock/list
export const RailHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px var(--cco-pad);
  border-bottom: 1px solid var(--cco-line);
`;

export const RailHeadChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 999px;
  background: var(--cco-cyan-soft);
  color: var(--cco-cyan);
  box-shadow: inset 0 0 0 1px rgba(28, 176, 216, 0.3);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

// Abas do rail: Variáveis | Comandos. Mesma familia visual do chip cyan —
// aba ativa preenche cyan-soft; inativa fica outline mute.
export const RailTabs = styled.div`
  display: inline-flex;
  gap: 6px;
`;

export const RailTab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: inherit;
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;

  ${(props) =>
    props.$active
      ? `
        background: var(--cco-cyan-soft);
        color: var(--cco-cyan);
        border: 1px solid var(--cco-cyan);
        box-shadow: inset 0 0 0 1px rgba(28, 176, 216, 0.3);
      `
      : `
        background: transparent;
        color: var(--cco-ink-faint);
        border: 1px solid var(--cco-line);
      `}

  &:hover {
    color: var(--cco-cyan);
    border-color: var(--cco-cyan);
  }

  /* contador opcional de itens na aba */
  .n {
    font-variant-numeric: tabular-nums;
    font-weight: 800;
    opacity: 0.85;
  }
`;

export const RailHeadIcons = styled.div`
  display: flex;
  gap: 6px;
`;

// $armed = comandos destravados (cadeado aberto). Sinaliza estado "ao
// vivo" em laranja — coerente com o chip DESBLOQUEADO do header da pagina
// e avisa o operador que os comandos enviam de fato pro equipamento.
export const RailHeadIconBtn = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  color: ${(props) => (props.$armed ? 'var(--cco-orange)' : 'var(--cco-ink-mute)')};
  background: ${(props) =>
    props.$armed ? 'var(--cco-orange-soft)' : 'transparent'};
  border: 1px solid
    ${(props) => (props.$armed ? 'var(--cco-orange)' : 'transparent')};
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;

  :hover {
    background: ${(props) =>
      props.$armed ? 'var(--cco-orange-soft)' : 'var(--cco-soft-surface-hover)'};
    color: ${(props) => (props.$armed ? 'var(--cco-orange)' : 'var(--cco-ink)')};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

// Commands section — cog icon + "Comandos" + empty state
export const CommandsBlock = styled.div`
  padding: 16px var(--cco-pad);
  border-bottom: 1px solid var(--cco-line);
`;

export const CommandsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--cco-ink-mute);
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  svg {
    color: var(--cco-ink-mute);
    width: 16px;
    height: 16px;
  }
`;

export const CommandsEmpty = styled.div`
  color: var(--cco-ink-faint);
  font-size: 12.5px;
  margin-top: 14px;
  letter-spacing: 0.06em;
`;

// Hint "Clique na variável para adicionar"
export const Hint = styled.div`
  padding: 14px var(--cco-pad) 6px;
  color: var(--cco-ink-mute);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

// Vars — area scrollavel. flex 1 absorve a altura restante do rail
// (depois de rail-head, commands, hint). overflow-y auto faz scroll
// suave. overscroll-behavior contain evita propagar pra pagina.
export const Vars = styled.div`
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
`;

// Linha de variavel (sem stripe — hairlines entre rows)
export const VarRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px var(--cco-pad);
  border-top: 1px solid var(--cco-line);
  transition: background 120ms ease;
  cursor: pointer;

  :first-child {
    border-top: 0;
  }

  :hover {
    background: rgba(78, 161, 243, 0.04);
  }

  /* Estilos de valor por tipo (passados via prop $style) */
  &[data-style='neg'] .val {
    color: var(--cco-red);
  }
  &[data-style='zero'] .val {
    color: var(--cco-ink-mute);
  }
`;

export const VarIco = styled.span`
  color: var(--cco-ink-mute);
  flex: none;
  width: 14px;
  height: 14px;
  display: grid;
  place-items: center;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const VarName = styled.span`
  flex: 1;
  font-size: 13.5px;
  color: var(--cco-ink);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const VarVal = styled.span.attrs({ className: 'val' })`
  color: var(--cco-cyan);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  font-size: 13.5px;
  white-space: nowrap;

  .u {
    color: var(--cco-ink-mute);
    font-weight: 500;
    font-size: 12px;
    margin-left: 4px;
  }
`;

// =============================================================================
// COMPAT — antigos exports ainda referenciados (HiddenThumb, VariablesCard,
// Line, Label, Title) mantidos como aliases / noops pra nao quebrar imports.
// =============================================================================
export const HiddenThumb = styled.div`
  display: none;
`;

export const VariablesCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Line = VarRow;
export const Label = VarName;
export const Title = Hint;
